var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"property-page"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.page.html)}}),_vm._l((_vm.groups),function(group,k){return [(group.is_registration)?_c('PropertyPageGroup',{key:k,attrs:{"group":group},on:{"attributes_selected":_vm.attributes_selected}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }